import { PartialType } from '@nestjs/swagger';
import { CreateRecepcionCompraDto } from './create-recepcion-compra.dto';

export class UpdateRecepcionCompraDto extends PartialType(CreateRecepcionCompraDto) {}

